import ACTIONS from 'application/constants'
import default_store from '../../../default_store'

const aktenActionNewFilesReducer = (state = default_store.pages.akten.action.newFiles, action) => {
    switch (action.type) {
    case ACTIONS.PAGES_AKTEN_REFRESH_NEW_FILES: return {
        ...state,
        request: false,
        succeed: false,
        failed: false,
    }
    case ACTIONS.PAGES_AKTEN_NEW_FILES_REQUEST: return {
        ...state,
        request: true,
    }
    case ACTIONS.PAGES_AKTEN_NEW_FILES_SUCCEED: return {
        ...state,
        request: false,
        succeed: true
    }
    case ACTIONS.PAGES_AKTEN_NEW_FILES_FAILED: return {
        ...state,
        request: false,
        succeed: false,
        failed: true
    }
    default:
        return state
    }
}

export default aktenActionNewFilesReducer